import React from "react";
import { EmptyOrders } from "../../svgs";
import { Box, Stack, Typography } from "@mui/material";

const ShipmentOrdersEmpty = () => {
  return (
    <Stack gap="25px" margin="auto" alignItems="center" padding="15px">
      <Box component="img" src={EmptyOrders} sx={{ height: "150px" }} />
      <Stack gap="10px" alignItems="center" textAlign="center">
        <Typography variant="boldCaption">No Shipment Orders Found</Typography>
        <Typography variant="caption" maxWidth="400px">
          Navigate to the <strong>Packages</strong> tab and select the packages
          you wish to create a shipment for.
        </Typography>
      </Stack>
    </Stack>
  );
};

export default ShipmentOrdersEmpty;
